import { render, staticRenderFns } from "./FilterDataOld.vue?vue&type=template&id=1280c075&scoped=true"
import script from "./FilterDataOld.vue?vue&type=script&lang=js"
export * from "./FilterDataOld.vue?vue&type=script&lang=js"
import style0 from "./FilterDataOld.vue?vue&type=style&index=0&id=1280c075&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1280c075",
  null
  
)

export default component.exports